import { TablePlaceHolder } from "@app/components/PlaceHolder";
import { memo } from "react";
import { useSimulatedForwardProbabilitiesAC } from "@app/pages/assetClassAnalysis/useSimulatedForwardProbabilitiesAC";
import { ChartSimulatedForwardProbabilitiesAC } from "@app/pages/assetClassAnalysis/ChartSimulatedForwardProbabilitiesAC";
import { CarPageContent } from "@app/components/PageContent";
import { CarPageContentCode, usePageContent } from "@app/hooks/usePageContent";

interface SimulationSimulatedForwardProbabilitiesProps {
  simulationJobId: string;
}

export const SimulationSimulatedForwardProbabilities = memo(
  (props: SimulationSimulatedForwardProbabilitiesProps) => {
    const data = useSimulatedForwardProbabilitiesAC({
      simulationJobId1: props.simulationJobId,
      simulationJobId2: props.simulationJobId,
    });

    const pageContent = usePageContent();

    return (
      <TablePlaceHolder
        sx={{ mx: 7, mt: 5 }}
        isLoading={data.isLoading || pageContent.isLoading}
        rows={8}
      >
        <CarPageContent
          sx={{ mb: 3 }}
          content={pageContent.getContent(
            CarPageContentCode.SIMULATION_ANALYSIS_PRICE_DRIVEN_SIMULATED_FORWARD_PROBABILITIES,
          )}
          isWhiteContext
        />
        <ChartSimulatedForwardProbabilitiesAC data={data} />
      </TablePlaceHolder>
    );
  },
);
